import { useState, useEffect, useCallback } from 'react'
import { getNotifications, markNotificationsAsViewed } from '@/api/notifications'

const typeLanguage = {
  en: 'en-US',
  pt: 'pt-BR',
}

export function usePlatformNotifications(language?: string) {
  const [notifications, setNotifications] = useState<Notification[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const formattedLanguage = typeLanguage[language as keyof typeof typeLanguage] || 'pt-BR'

  useEffect(() => {
    const fetchPlatformNotifications = async () => {
      try {
        setError(null)
        const response = await getNotifications({
          type: 'platform_notification',
          page: 1,
          items_per_page: 20,
          language: formattedLanguage,
        })
        setNotifications(response.notifications)
      } catch (_error) {
        setError('Failed to fetch platform notifications')
      } finally {
        setLoading(false)
      }
    }

    fetchPlatformNotifications()
  }, [formattedLanguage])

  const markAsViewed = useCallback(async (notificationIds: string[]) => {
    try {
      await markNotificationsAsViewed({
        notification_external_ids: notificationIds
      })
      
      setNotifications(prev => 
        prev.map(notification => ({
          ...notification,
          viewed_at: notificationIds.includes(notification.external_id) 
            ? new Date().toISOString() 
            : notification.viewed_at
        }))
      )
    } catch (_error) {
      // Ignora erro
    }
  }, [])

  const unreadCount = notifications.filter(n => n.viewed_at === null).length

  return {
    notifications,
    loading,
    error,
    unreadCount,
    markAsViewed,
  }
} 